module.exports = __webpack_public_path__ + "img/live.8ff97238.png";